import Head from "next/head";
import { useEffect } from "react";
import { DefaultSeo } from "next-seo";
import { useRouter } from "next/router";

import Header from "components/Header";

import "../styles/main.scss";
import { isDev } from "/constants";

import { AppProps } from "next/app";

// eslint-disable-next-line react/prop-types
function MyApp({ Component, pageProps }: AppProps<{ draftMode: boolean; token: string }>) {
  const router = useRouter();

  useEffect(() => {
    if (!isDev) {
      import("react-facebook-pixel")
        .then((x) => x.default)
        .then((ReactPixel) => {
          ReactPixel.init("482734776770913"); // facebookPixelId
          ReactPixel.pageView();

          // Track Whee! Bike purchase. The successful order flow redirects to
          // /sykler/bestilt?status=ok, so match that exact URL (the bare path
          // never matches due to the query string).
          if (router.asPath === "/sykler/bestilt?status=ok") {
            ReactPixel.track("Purchase");
          }
          // Track test ride booking from calendly
          if (router.asPath === "/service/calendly-booking-confirmed") {
            ReactPixel.track("Schedule");
          }

          router.events.on("routeChangeComplete", () => {
            ReactPixel.pageView();
          });
          return () => {
            router.events.off("routeChangeComplete", ReactPixel.pageView);
          };
        });
    }
  }, [router.events, router.asPath]);

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        <meta charSet="utf-8" />
        <meta
          name="google-site-verification"
          content="M7fEOP5BBe6sat3elSdQ6tLiODS_OQTbCz4pC2EN8x4"
        />
        <meta property="fb:admins" content="103027534890783" />

        <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
        <link rel="manifest" href="/manifest.json" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="facebook-domain-verification" content="a77dkfay70ykrpqbu22ewf8tfebflv" />

        {/*PWA setup*/}
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-touch-fullscreen" content="yes" />
        <meta name="apple-mobile-web-app-title" content="Min Whee!" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />

        <link
          rel="apple-touch-startup-image"
          href="/images/splashScreen/iphone5_splash.png"
          media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2)"
        />
        <link
          rel="apple-touch-startup-image"
          href="/images/splashScreen/iphone6_splash.png"
          media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)"
        />
        <link
          rel="apple-touch-startup-image"
          href="/images/splashScreen/iphoneplus_splash.png"
          media="(device-width: 621px) and (device-height: 1104px) and (-webkit-device-pixel-ratio: 3)"
        />
        <link
          rel="apple-touch-startup-image"
          href="/images/splashScreen/iphonex_splash.png"
          media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)"
        />
      </Head>
      <DefaultSeo
        openGraph={{
          type: "website",
          locale: "nb_NO",
          url: "https://whee.no/",
          site_name: "Whee!"
        }}
      />

      <Header />
      <div data-animate-in key={router.asPath}>
        <Component {...pageProps} path={router.asPath} />
      </div>
    </>
  );
}

export default MyApp;
